import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import InstallPrompt from './InstallPrompt';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      <InstallPrompt />
    </ErrorBoundary>
  </React.StrictMode>
);

// Bascule anti-flash (voir public/index.html) : une fois React monté, on
// révèle le vrai contenu et on retire le loader neutre affiché en attendant.
// IMPORTANT : le masquage vient d'une règle CSS injectée dans une balise
// <style> séparée (#root{visibility:hidden}), PAS d'un style inline sur
// #root — removeProperty() n'agit que sur le style inline de l'élément et
// n'a donc AUCUN EFFET sur une règle de feuille de style externe. Il faut
// explicitement FIXER un style inline `visibility:visible` pour gagner en
// spécificité et neutraliser la règle CSS (bug vécu : page blanche
// permanente pour tout visiteur déjà connecté, car #root restait caché
// pour toujours malgré le montage réussi de React en dessous).
const rootEl = document.getElementById('root');
if (rootEl) rootEl.style.visibility = 'visible';
const bootLoader = document.getElementById('boot-loader');
// La règle CSS injectée utilise !important (sinon elle ne peut jamais
// battre le display:none inline par défaut du div) — il faut donc aussi
// !important ici, sinon une simple affectation ne suffit plus à la battre.
if (bootLoader) bootLoader.style.setProperty('display', 'none', 'important');

// Enregistrement du service worker (PWA installable + offline)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker non enregistré:', err);
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
